<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="auto"
    :disabled="disabled"
  >
    <template #activator="{ on, attrs }">
      <span :class="labelClass">
        <span class="mt-3">{{ label }}</span>

        <v-text-field
          :value="displayValue"
          v-bind="attrs"
          readonly
          required
          :rules="rules"
          :error-messages="errors"
          class="search-input ml-3"
          solo
          dense
          :disabled="disabled"
          v-on="on"
        >
          <template #append>
            <v-icon color="black">mdi-calendar-blank</v-icon>
          </template>
        </v-text-field>
      </span>
    </template>

    <v-date-picker
      v-model="pickerValue"
      :max="maxDateISO"
      :min="minDateISO"
      locale="es"
      @input="menu = false"
    />
  </v-menu>
</template>

<script>
  function parseLocalDate(iso) {
    if (typeof iso !== 'string') return null;
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso.trim());
    if (!match) return null;
    const [, y, m, d] = match;
    const date = new Date(Number(y), Number(m) - 1, Number(d));
    return isNaN(date.getTime()) ? null : date;
  }

  function formatLocalDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  export default {
    name: 'LocalDatePicker',

    props: {
      value: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      labelClass: {
        type: String,
        default: 'in-line',
      },
      maxDate: {
        type: Date,
        default: null,
      },
      minDate: {
        type: Date,
        default: null,
      },
      errors: {
        type: [Array, String],
        default: () => [],
      },
      rules: {
        type: Array,
        default: () => [],
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        menu: false,
      };
    },

    computed: {
      normalizedValue() {
        const date = parseLocalDate(this.value);
        return date ? formatLocalDate(date) : '';
      },

      displayValue() {
        return this.normalizedValue;
      },

      pickerValue: {
        get() {
          return parseLocalDate(this.value);
        },

        set(value) {
          if (!value) {
            this.$emit('input', '');
            return;
          }

          const date = value instanceof Date ? value : parseLocalDate(value);
          this.$emit('input', date ? formatLocalDate(date) : '');
        },
      },

      maxDateISO() {
        const maxDate = this.maxDate
          ? formatLocalDate(this.maxDate)
          : formatLocalDate(new Date());
        return maxDate;
      },

      minDateISO() {
        return this.minDate ? formatLocalDate(this.minDate) : undefined;
      },
    },
  };
</script>

<style scoped>
  .search-input {
    border-radius: 5px;
    padding-right: 0;
  }

  .in-line {
    display: flex;
    color: black;
    font-weight: bold;
  }
</style>
```
